import styled from 'styled-components'

import breakpoints from '../../constants/ui/breakpoints'

export const UseVoiceControlStyled = styled.div`
  background-color: ${({ theme }) => theme.backgroundDark};

  .title {
    max-width: 880px;
    margin-bottom: 2rem;

    @media (max-width: ${breakpoints.screenMD}) {
      max-width: 650px;
      margin-bottom: 0;
    }
  }

  .device-group {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 2rem;
    width: 90%;
    margin-bottom: 3rem;

    @media (max-width: ${breakpoints.screenMD}) {
      width: 100%;
    }

    @media (max-width: ${breakpoints.screenSM}) {
      flex-direction: column;
      align-items: center;
    }
  }

  .device {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    white-space: nowrap;
  }

  .img {
    &.watch {
      max-width: 60px;
    }

    &.computer {
      max-width: 600px;
    }

    &.other-devices {
      max-width: 470px;
    }
  }
`
